// Shim para que `import { ... } from '@env'` (configurado vía react-native-dotenv en Babel para móvil)
// funcione también en el build web de Vite. Lee de `import.meta.env` (Vite) o `process.env`.

const env = (typeof import.meta !== 'undefined' && (import.meta as any).env) || {};

function get(key: string): string {
  // Vite expone vars con prefijo VITE_ por defecto, pero como replicamos las mismas keys,
  // probamos con y sin prefijo + process.env como fallback (build SSR).
  return env[`VITE_${key}`] ?? env[key] ?? (typeof process !== 'undefined' ? process.env[key] : undefined) ?? '';
}

export const APP_ENV = get('APP_ENV') || 'local';
export const FIREBASE_API_KEY = get('FIREBASE_API_KEY') || 'demo-clinicat';
export const FIREBASE_AUTH_DOMAIN = get('FIREBASE_AUTH_DOMAIN') || 'clinicat-f314b.firebaseapp.com';
export const FIREBASE_PROJECT_ID = get('FIREBASE_PROJECT_ID') || 'clinicat-f314b';
export const FIREBASE_STORAGE_BUCKET = get('FIREBASE_STORAGE_BUCKET') || 'clinicat-f314b.firebasestorage.app';
export const FIREBASE_MESSAGING_SENDER_ID = get('FIREBASE_MESSAGING_SENDER_ID') || '150517385947';
export const FIREBASE_APP_ID = get('FIREBASE_APP_ID') || '1:150517385947:web:demo';
export const FIREBASE_MEASUREMENT_ID = get('FIREBASE_MEASUREMENT_ID') || '';
export const USE_FIREBASE_EMULATOR = get('USE_FIREBASE_EMULATOR') || 'true';
export const CLOUDINARY_CLOUD_NAME = get('CLOUDINARY_CLOUD_NAME') || '';
export const CLOUDINARY_UPLOAD_PRESET = get('CLOUDINARY_UPLOAD_PRESET') || '';
